module.exports = __webpack_public_path__ + "img/dep_grocery@3x.53c95d24.png";